import { GetDocumentUploadResponse } from '@iwoca/lapi-client/edge';
import { Button } from '@iwoca/orion';
import classnames from 'classnames';
import { useField } from 'formik';
import { useDropzone } from 'react-dropzone';

import styles from './DocumentUpload.module.css';
import { ReactComponent as Check } from '../../../../components/svg/Check.svg';
import { CrossBoxIcon } from '../../../../components/svg/CrossBoxIcon';
import FileUploadIcon from '../../../../components/svg/FileUploadIcon.svg';

export const DocumentUpload = ({
  filesName,
  uploadedFiles,
  isPendingDocumentChecks,
}: {
  filesName: string;
  uploadedFiles: GetDocumentUploadResponse['data'];
  isPendingDocumentChecks: boolean;
}) => {
  const [filesField, { value: files }, { setValue: setFiles }] =
    useField<File[]>(filesName);

  const onDrop = (acceptedFiles: File[]) =>
    setFiles(files.concat(acceptedFiles));

  const onRemove = async (file: File) => {
    const temp = files;
    const fileIndex = files.findIndex((f) => f.name === file.name);

    if (fileIndex < 0) return;

    temp.splice(fileIndex, 1);
    await setFiles(temp);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: { 'application/pdf': ['.pdf'] },
    onDrop,
  });

  return (
    <>
      <div className={styles.uploadedFilesContainer}>
        {uploadedFiles.map((item) => (
          <UploadedFile
            //@ts-expect-error
            key={item?.attributes?.document_name || ''}
            //@ts-expect-error
            fileName={item?.attributes?.document_name || ''}
          />
        ))}
      </div>
      {!isPendingDocumentChecks && (
        <>
          {files.map((item) => (
            <UploadedFile
              key={item.name}
              onRemoveFile={() => onRemove(item)}
              fileName={item.name}
            />
          ))}
          <div
            {...filesField}
            {...getRootProps()}
            className={classnames(styles.documentUploadContainer, {
              [styles.documentUploadContainerActive]: isDragActive,
            })}
          >
            <div className={styles.textContainer}>
              <div className={styles.header}>
                <img
                  className={styles.uploadIcon}
                  src={FileUploadIcon}
                  alt="File upload icon"
                />{' '}
                Upload
              </div>
              <div className={styles.body}>or drag and drop</div>
            </div>
            <input {...getInputProps()} />
          </div>
          <div
            {...filesField}
            {...getRootProps()}
            className={styles.documentUploadContainerMobile}
          >
            <Button
              variant="secondary"
              className={styles.documentUploadButtonMobile}
            >
              Upload
            </Button>
            <input {...getInputProps()} />
          </div>
        </>
      )}
    </>
  );
};

const UploadedFile = ({
  fileName,
  onRemoveFile,
}: {
  fileName: string;
  onRemoveFile?: () => void;
}) => (
  <div className={styles.uploadedFile}>
    <div className={styles.uploadedFileTextContainer}>{fileName}</div>
    <div className={styles.uploadedFileStatusContainer}>
      {onRemoveFile && (
        <button className={styles.uploadedFileRemove} onClick={onRemoveFile}>
          <CrossBoxIcon />
          <p>Remove</p>
        </button>
      )}

      <div className={styles.uploadedFileValid}>
        <Check />
      </div>
    </div>
  </div>
);
